export {
  AccreditedInvestorGate,
  ACCREDITED_INVESTOR_GATE_CONTENT_MODEL_ID,
} from './AccreditedInvestorGate'
export type { AccreditedInvestorGateFields } from './types'
